import React, { useContext, useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { Box, Breadcrumbs, Stack, Typography } from '@mui/material';
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Links from "@mui/material/Link";
import { useSnackbar } from 'notistack';
import { initializeProcess, postProcess } from './workflow';
import Loading from '../../components/Loading';

const AssociateProcess: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  
  

  const navigate = useNavigate();
  const location=useLocation();
  const id = location.state?.id as string;

  // Handle breadcrumb navigation to view-xevmpd
  const handleBreadcrumbClick = () => {
 
    navigate("/view-xevmpd", { state: { params, mode: "view" } });
  };
  const params= location.state?.params as any;



  // const origin = "https://pat.devsecops.freyafusion.com";
  const origin = window.location.origin.replace('xevmpd.', 'PAT.');

  const IframeUrl = `${origin}/process/associate?moduleId=35&objectId=xEVMPD-${id}`;
  console.log("AssociateProcess IframeUrl:", IframeUrl);

  const associateSuccessCallback = (params: API.PostProcessBody) => {
    setLoading(true);
    
    // Start the 2-second timer immediately when callback is called
    const navigationTimer = setTimeout(() => {
      setLoading(false);
      navigate("/xevmpd");
    }, 3000);
    
    // // Debug alert for params
    // alert(`AssociateProcess Params_Get : objectId=${params.objectId}, processAssociationId=${params.processAssociationId}, processStatus=${params.processStatus}`);
    
    postProcess(params)
      .then((res) => {
        if (res.code === 200 && res.data) {
          // Show success message immediately
          enqueueSnackbar(t("workflow.associatedSuccessfully"), {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "center" },
            autoHideDuration: 2000,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        // Clear the timer if there's an error
        clearTimeout(navigationTimer);
        setLoading(false);
      });
  };

  const initiateComplete = (params: API.PostProcessBody) => {
    setLoading(true);
    
    // Start the 2-second timer immediately when callback is called
    const navigationTimer = setTimeout(() => {
      setLoading(false);
      navigate("/xevmpd");
    }, 2000);
    
    initializeProcess(params)
      .then((res) => {
        if (res.code === 200 && res.data) {
          // Show success message immediately
          enqueueSnackbar(t("workflow.initiatedSuccessfully"), {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "center" },
            autoHideDuration: 2000,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        // Clear the timer if there's an error
        clearTimeout(navigationTimer);
        setLoading(false);
      });
  };

  useEffect(() => {
    const handlePTMessage = (event: any) => {
      const { type } = event.data;
      switch (type) {
        case "ptAssociateCancel":
          navigate("/xevmpd");
          break;
        case "ptAssociateSuccess":
          associateSuccessCallback(event.data.data.extraData);
          // Navigation is handled inside associateSuccessCallback with 2-second delay
          break;
        case "ptInitiateComplete":
          initiateComplete(event.data.data.extraData);
          // Navigation is handled inside initiateComplete with 2-second delay
          break;
        default:
          break;
      }
    };
    window.addEventListener("message", handlePTMessage);
    return () => {
      window.removeEventListener("message", handlePTMessage);
    };
  });

 

return (
  <>
  
    <Box >
  <Stack>
    <div style={{marginTop:"16px",marginLeft:"32px"}}>
      <Breadcrumbs 
        id="breadcrumb-associate-process" 
        aria-label="breadcrumb" 
        separator={<span>/</span>}
         sx={{
          '& .MuiBreadcrumbs-separator': {
            marginLeft: '12px',   // Space BEFORE separator (after item)
            marginRight: '12px',  // Space AFTER separator (before next item)
          }
        }}
      >
        <Links href="/xevmpd" sx={{ color: "#295ef1", fontWeight: 400 }}>{t("xEVMPD")}</Links>
        <Links onClick={handleBreadcrumbClick} sx={{ color: "#295ef1", fontWeight: 400 }}>
          { "xEVMPD-"+id }
        </Links>
        <Typography data-testid="breadcrumb-edit-app">{t("workflow.associateProcess")}</Typography>
      </Breadcrumbs>
    </div>
  </Stack>
</Box>
  <Loading open={loading}></Loading>
  {!!IframeUrl ? (
    <Iframe
      url={IframeUrl}
      width="100%"
      height="600px"
      frameBorder={0}
      allow="clipboard-read; clipboard-write"
      title="Associate Process"
      id="xevmpd_associate_process_iframe"
      onLoad={() => {
        setTimeout(() => {
          const curIframe = document.getElementById(
            "xevmpd_associate_process_iframe"
          ) as HTMLIFrameElement | null;
          curIframe?.contentWindow?.postMessage(
            { type: "globalLanguageChange", data: "en" },
            origin
          );
          setLoading(false);
        }, 600);
      }}
    />
  ) : null}
  </>
);
};

export default AssociateProcess;